import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-with-side-bar" }
const _hoisted_2 = { class: "page-with-side-bar__content" }

import { watch, type PropType, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';

import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';

import AppHeader from './app-header/AppHeader.vue';

export type ShouldExecuteRedirect = (showLeftNav: boolean) => {
  doIt: boolean;
  route: {
    name: string;
    params?: Dictionary<string>;
    hash?: string;
  };
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PageWithSideBar',
  props: {
  /** Callback to be executed on route change */
  onRouteChange: { type: Function as PropType<(mainEl: HTMLElement) => void>, required: false },
  /** Condition to show left nav */
  showLeftNav: { type: Boolean, required: true },
  /** Condition if redirect to default route is required */
  shouldExecuteRedirect: { type: Function as PropType<ShouldExecuteRedirect>, required: false },
},
  setup(__props) {

const props = __props;

const { isXS } = useMQBreakpoints();
const route = useRoute();
const router = useRouter();

const mainEl = ref<HTMLElement>();

watch(
  () => props.showLeftNav,
  () => {
    if (!props.shouldExecuteRedirect) {
      return;
    }

    const { doIt, route: routeObj } = props.shouldExecuteRedirect(props.showLeftNav);

    if (doIt) {
      router.push(routeObj);
    }
  },
  { immediate: true },
);

watch(route, () => {
  if ((props.onRouteChange ?? props.onRouteChange === 'function') && mainEl.value) {
    props.onRouteChange(mainEl.value);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_ot_module_container = _resolveComponent("ot-module-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isXS))
      ? (_openBlock(), _createBlock(AppHeader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (__props.showLeftNav)
        ? (_openBlock(), _createBlock(_component_ot_module_container, {
            key: 0,
            class: "page-with-side-bar__left-nav",
            "with-bottom-padding": true
          }, {
            "main-content": _withCtx(() => [
              _renderSlot(_ctx.$slots, "leftNav")
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref_key: "mainEl",
        ref: mainEl,
        class: "page-with-side-bar__main"
      }, [
        _renderSlot(_ctx.$slots, "default", { withLeftNav: __props.showLeftNav })
      ], 512)
    ])
  ]))
}
}

})